import { Injectable } from '@angular/core';
import { Observable, filter, take, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { PersonalizationService as NgrxPersonalizationService } from '@usf/ngrx-product';
import { selectPersonalizationViewModel } from '@shared/selectors/merchandising.selectors';
import { MerchandisingProductViewModel } from '@shared/models/merchandising-product-view.model';

@Injectable({
  providedIn: 'root',
})
export class PersonalizationService {
  constructor(
    private personalizationService: NgrxPersonalizationService,
    private store: Store,
  ) {}

  loadPersonalizationProducts$(
    personalizationType: string,
  ): Observable<MerchandisingProductViewModel[]> {
    return this.store
      .select(selectPersonalizationViewModel(personalizationType))
      .pipe(
        filter(products => {
          if (products?.length === 0) return false;
          return products?.every(
            val =>
              !!val.summary && !!val.pricing && val.pricing.loading === false,
          );
        }),
        take(1),
      );
  }
  getPersonalizationProductNumbers$(
    personalizationType: string,
  ): Observable<number[]> {
    return this.personalizationService
      .getPersonalization(personalizationType)
      .pipe(
        filter((state: any) => !!state?.response?.products),
        take(1),
        map((state: any) => state.response.products as number[]),
      );
  }
}
